import {
    Switch,
    Route,
    useHistory,
    useRouteMatch,
  } from "react-router-dom";
import Location from "./Location";
import { firestore } from "./firebase";
import Fusion from "./Fusion";
import Sidebar from "./Sidebar";

export default function Locations() {
    const history = useHistory();

    const newLocation = () => {
        const reference = firestore.collection('locations').doc();
        history.push(`/location/${reference.id}`);
    };

    let match = useRouteMatch();
    
    return <div className="h-full flex w-auto">
        <Sidebar newItem={newLocation} newItemText="Neue Location" collection="locations" showSearch={true} itemTitle={(item) => item.name} itemLink={(item) => `/locations/${item.objectID}`} />
        <div className="flex-grow overflow-auto">
            <Switch>
                <Route path={`${match.path}/:id1/fusion/:id2`}><Fusion collection="locations" recordType="location" /></Route>
                <Route path={`${match.path}/:id1/fusion`}><Fusion collection="locations" recordType="location" /></Route>
                <Route path={`${match.path}/:id`} component={Location}/>
                <Route path={match.path}>
                    <p className="p-3">
                        Bitte selektiere einen Location.
                    </p>
                </Route>
            </Switch>
        </div>
    </div>;
}